import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import LanguageInitializer from "./initializers/LanguageInitializer";
import _forOwn from "lodash/forOwn";
import _map from "lodash/map";
import ApiErrorModalInitializer from "./initializers/ApiErrorModalInitializer";
import ConfigInitializer from "./initializers/ConfigInitializer";

class AppInitializer extends Component {

  constructor(props) {
    super(props);
    this.initializerComponents = {
      //We also have it in here, because api calls can be made while loading the app
      apiErrorModalInitializer: {
        isLoaded: false,
        component: ApiErrorModalInitializer
      },
      languageInitializer: {
        isLoaded: false,
        component: LanguageInitializer
      },
      configInitializer: {
        isLoaded: false,
        component: ConfigInitializer
      }
    };
  }

  //TODO: potentially add some error handling if necessary if a configuration has errors
  updateState = (configurationLoadedKey) => {
    this.initializerComponents[configurationLoadedKey].isLoaded = true;
    if (this.isLoaded()) {
      this.props.onLoaded();
    }
  };

  isLoaded = () => {
    let isLoaded = true;
    _forOwn(this.initializerComponents, function (value, key) {
      if (!value.isLoaded) {
        isLoaded = false;
        return false;
      }
    });
    return isLoaded;
  };

  render() {
    let components = _map(this.initializerComponents, (componentInfo, initializerKey) => {
     const Initializer = componentInfo.component;
     return (!componentInfo.isLoaded && <Initializer key={initializerKey} updateState={this.updateState}/>);
    });

    return (
        <div>
          {components}
        </div>
    )
  }
}

AppInitializer.propTypes = {
  onLoaded: PropTypes.func.isRequired
};

export default AppInitializer;